import React from "react";
import { Navigate } from "react-router-dom";
import checkAuth from "../app/auth";

const PrivateRoute = ({ children }) => {
  const token = checkAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;